import React from 'react'
import { RuleCard } from './RuleCard'

interface Props {
    schema: Record<string, any>
    config: Record<string, any>[]
    path: string[]
    pathWithElementID: string | undefined
    setCardToDeleteElementID: React.Dispatch<
        React.SetStateAction<null | string>
    >
    inCard?: boolean
    isRuleActive?: boolean
    focusIndex: number
    isNewCardAdded: boolean
}

export const RuleCardsList = ({
    schema,
    config,
    path,
    setCardToDeleteElementID,
    inCard,
    isRuleActive,
    focusIndex,
    isNewCardAdded,
    pathWithElementID,
}: Props) => {
    return (
        <>
            {config.map((el: any, index: number) => (
                <div
                    key={String(el?.element_id ?? index)}
                    className="hover flex-column mw-350 rounded bg-white justify-content-between p-relative d-flex m-1 border"
                >
                    <RuleCard
                        index={index}
                        schema={schema}
                        config={el}
                        dataPath={path}
                        setCardToDeleteElementID={setCardToDeleteElementID}
                        rulesBlocks={config}
                        element_id={el.element_id}
                        inCard={inCard}
                        isParentCardActive={isRuleActive}
                        focusIndex={focusIndex}
                        isNewCardAdded={isNewCardAdded}
                        pathWithElementID={pathWithElementID}
                    />
                </div>
            ))}
        </>
    )
}
